var React = require('react');

function ActivitiesIconSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .activities-icon-small-svg {\n      fill: #9b9b9b;\n      fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"className":"activities-icon-small-svg","d":"M150.5,184c0.825,0,1.5-1.1,1.5-2h-3C149,182.9,149.663,184,150.5,184Zm4.874-4.923v-4.1c0-2.519-1.332-4.627-3.656-5.185v-0.558a1.219,1.219,0,1,0-2.437,0v0.558c-2.331.558-3.656,2.658-3.656,5.185v4.1L144,180.718,144,181h13l-0.006-.282Z","transform":"translate(-144 -168)","key":1})]);
}

ActivitiesIconSmall.defaultProps = {"width":"13","height":"16","viewBox":"0 0 13 16"};

module.exports = ActivitiesIconSmall;

ActivitiesIconSmall.default = ActivitiesIconSmall;
